import { UserRole } from '../enums';

// Cockpit translation keys for the platform roles. Role names are user-facing in
// the admin back-office, so this layer owns the key rather than an English
// label — consumers resolve it with t(). Keyed exhaustively so a new UserRole
// member cannot be added without also giving it a label.
export const UserRoleLabelKeys: Record<UserRole, string> = {
  [UserRole.ADMIN]: 'admin_user_role_admin',
  [UserRole.APPROVER]: 'approver',
  [UserRole.COMPANY_ADMIN]: 'company_admin',
  [UserRole.FAN]: 'admin_user_role_fan',
  [UserRole.FAN_GROUP_DEVELOPER]: 'admin_user_role_developer',
  [UserRole.FAN_GROUP_OWNER]: 'audience_owner',
  [UserRole.GUEST]: 'admin_user_role_guest',
  [UserRole.HOST]: 'host',
  [UserRole.TRANSLATOR]: 'admin_user_role_translator',
};

// Role picker options in display order. `labelKey` must be passed through t()
// by the consumer — there is no i18n instance in this layer.
export const UserRoleOptions = [
  { labelKey: UserRoleLabelKeys[UserRole.ADMIN], value: UserRole.ADMIN },
  {
    labelKey: UserRoleLabelKeys[UserRole.COMPANY_ADMIN],
    value: UserRole.COMPANY_ADMIN,
  },
  { labelKey: UserRoleLabelKeys[UserRole.APPROVER], value: UserRole.APPROVER },
  { labelKey: UserRoleLabelKeys[UserRole.FAN], value: UserRole.FAN },
  {
    labelKey: UserRoleLabelKeys[UserRole.FAN_GROUP_OWNER],
    value: UserRole.FAN_GROUP_OWNER,
  },
  {
    labelKey: UserRoleLabelKeys[UserRole.FAN_GROUP_DEVELOPER],
    value: UserRole.FAN_GROUP_DEVELOPER,
  },
  { labelKey: UserRoleLabelKeys[UserRole.GUEST], value: UserRole.GUEST },
  { labelKey: UserRoleLabelKeys[UserRole.HOST], value: UserRole.HOST },
  {
    labelKey: UserRoleLabelKeys[UserRole.TRANSLATOR],
    value: UserRole.TRANSLATOR,
  },
];
